import moment from 'moment';

export const isBelowDayDuration = (
  startDate: string,
  maxDays: number,
): boolean => {
  // Parse the dates using moment
  const parsedStartDate = moment(startDate);
  const parsedEndDate = moment();

  // Calculate the difference in days
  const daysDifference = parsedEndDate.diff(parsedStartDate, 'days');

  // Check if the difference is within the specified maximum number of days
  return daysDifference <= maxDays;
};

export const getStartOfDay = (date: Date): Date => {
  if (date) {
    return moment(date).startOf('day').toDate();
  }

  return date;
};

export const getEndOfDay = (date: Date): Date => {
  if (date) {
    return moment(date).endOf('day').toDate();
  }

  return date;
};
